'use strict';

import analytics from '../../utils/analytics';
import phoneNumberReplacement from '../../utils/phone-number-replacement';
import layout from '../../ui/layout';
import isMobile from 'is-mobile';

const classNames = {
	callDealer: 'call-dealer',
	loadingModifier: 'loading',
	labelElement: 'label',
	triggered: 'triggered',
	mobileLazyLoad: 'mobile-lazy-load'
};

const modifiers = {
	oneClickCandidate: 'one-click-candidate',
	loaded: 'loaded'
};

const dataAttrNames = {
	dealerId: 'data-dealer-id',
	dealerPhoneNumberReplacement: 'data-dealer-phone-number-replacement',
	parkersVehicleId: 'data-parkers-vehicle-id'
};

const getVehicleData = ($element) => {
	let result = null;
	const $hasData = $($element).closest('*[' + dataAttrNames.parkersVehicleId + ']');

	if ($hasData && $hasData.length > 0) {
		const dataset = $hasData[0].dataset;
		result = {
			id: dataset.parkersVehicleId,
			stockId: dataset.stockId,
			sourceVehicleId: dataset.sourceVehicleId
		};
	}

	return result;
};

const getDealerData = ($element) => {
	let result = null;
	const $hasData = $($element).closest('*[' + dataAttrNames.dealerId + ']');

	if ($hasData && $hasData.length > 0) {
		const dataset = $hasData[0].dataset;
		result = {
			id: dataset.dealerId,
			sourceDealerId: dataset.dealerSourceDealerId,
			sellerType: dataset.dealerSellertype,
			name: dataset.dealerName,
			phoneNumber: dataset.dealerPhoneNumber,
			sourceName: dataset.dealerSource,
			phoneNumberAdvId: dataset.dealerPhoneNumberAdvId
		};
	}

	return result;
};

const resetClickTracking = ($clickElements) => {
	const trackingData = $clickElements.data('ga-track');
	trackingData.category = 'Call CFS Dealer';
	$clickElements.attr('data-ga-track', JSON.stringify(trackingData));
	analytics.initClickTracking($clickElements);
};

const replacePhoneNumber = (e) => {
	e.preventDefault();

	const $phoneNumber = $(e.target);
	const vehicleData = getVehicleData($phoneNumber);
	const dealerData = getDealerData($phoneNumber);

	if (!dealerData) {
		return null;
	}

	let $matchingCallButtons = [];

	if (vehicleData !== null) {
		// Find the buttons for the appropriate vehicle, for safety on results pages with multiple vehicles
		$matchingCallButtons = $('*[' + dataAttrNames.dealerPhoneNumberReplacement + '="required"]').filter(function (index, $element) {
			const elementVehicleData = getVehicleData($element);
			return elementVehicleData && elementVehicleData.id === vehicleData.id;
		});
	} else {
		// TODO: When Dealer page done, logic here for button if phone number not associated to a specific vehicle
	}

	$matchingCallButtons.addBemClass(classNames.callDealer, null, classNames.loadingModifier);

	phoneNumberReplacement.getPhoneNumber(e.target, vehicleData, dealerData).then((phoneNumberData) => {
		$matchingCallButtons.removeBemClass(classNames.callDealer, null, classNames.loadingModifier);

		// Update button click events and text
		$matchingCallButtons
			.removeBemClass(classNames.callDealer, null, classNames.loadingModifier)
			.attr('href', 'tel:' + phoneNumberData.international)
			.attr(dataAttrNames.dealerPhoneNumberReplacement, 'succeeded')
			.off('click.callDealer');

		$matchingCallButtons
			.findByBem(classNames.callDealer, null, modifiers.loaded)
			.childrenByBem(classNames.callDealer, classNames.labelElement)
			.html(phoneNumberData.local);

		// Update GA event tracking to reflect that this is now a call button
		resetClickTracking($matchingCallButtons);
	});
};

const oneClickCall = {

	initPhoneCall: async(contactDealerButton, vehicleData, dealerData) => {
		$(contactDealerButton).addBemClass(classNames.callDealer, null, classNames.loadingModifier);
		await phoneNumberReplacement.getPhoneNumber(contactDealerButton, vehicleData, dealerData)
			.then((phoneNumberData) => {
				const phoneNumber = phoneNumberData.international;
				$(contactDealerButton).removeBemClass(classNames.callDealer, null, classNames.loadingModifier);
				window.location.href = 'tel:' + phoneNumber;
			});
	},

	initMobileCallDealerTrigger: ($phoneNumbersToReplace) => {
		if ($phoneNumbersToReplace.length === 0) {
			return;
		}

		// Get all the Call Dealer buttons that are visible (including those that are off-screen but have the one-click candidate modifier).
		const $visiblePhoneNumbers = $phoneNumbersToReplace.filter((index, element) => {
			return $(element).is(':visible') || $(element).hasBemClass(classNames.callDealer, null, modifiers.oneClickCandidate);
		});

		// Update GA event tracking to reflect that this is now a call button
		resetClickTracking($visiblePhoneNumbers);
		
		$($visiblePhoneNumbers).on('click.callDealer', async(event) => {
			const contactDealerButton = event.currentTarget;
			const vehicleData = getVehicleData(contactDealerButton);
			const dealerData = getDealerData(contactDealerButton);
			await oneClickCall.initPhoneCall(contactDealerButton, vehicleData, dealerData);
		});
	}
};

export default {
	init() {
		const $phoneNumbersToReplace = $('*[' + dataAttrNames.dealerPhoneNumberReplacement + '="required"]');

		// We can't just check the screen size, we also need to make sure the user is on a mobile device.
		if (isMobile() || layout.isMobile()) {
			oneClickCall.initMobileCallDealerTrigger($phoneNumbersToReplace);
		} else {
			$phoneNumbersToReplace.off('click.callDealer').on('click.callDealer', replacePhoneNumber);
		}
	}
}